module.exports = "<svg viewBox=\"0 0 16 16\"><path d=\"M8.393.26L10.6 4.635l4.924.7a.468.468 0 0 1 .263.802l-3.56 3.396.84 4.801c.068.383-.339.677-.688.497l-4.413-2.27-4.41 2.27c-.35.18-.757-.114-.69-.497l.841-4.8L.146 6.136a.468.468 0 0 1 .263-.802l4.925-.7L7.54.26a.479.479 0 0 1 .853 0\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/star.svg
// module id = 287
// module chunks = 0 1